var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArea42Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 54,
    viewBox: "0 0 276 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_1237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3419 52.1903H45.9131L25.988 1.13672H19.915L0 52.1903H8.49002L12.735 40.6182H33.1578L37.3317 52.1903H37.3419ZM15.3044 33.5164L22.9921 12.5666L30.6088 33.5164H15.3044ZM89.8561 52.1903L76.0141 29.554C82.3816 27.6541 85.8244 22.8891 85.8244 15.6349C85.8244 6.48084 80.4013 1.13672 68.6209 1.13672H52.6564V52.1903H60.4152V30.5091H68.2451L80.6958 52.1903H89.846H89.8561ZM60.4254 23.326V8.38074H67.8186C74.4806 8.38074 77.9234 10.3619 77.9234 15.7772C77.9234 21.1924 74.4806 23.326 67.8186 23.326H60.4254ZM97.0361 52.1903H130.793V44.9362H104.876V29.6251H128.671V22.371H104.876V8.38074H130.793V1.13672H97.0361V52.1903ZM172.096 52.1903H180.667L160.742 1.13672H154.669L134.754 52.1903H143.244L147.489 40.6182H167.911L172.085 52.1903H172.096ZM150.058 33.5164L157.746 12.5666L165.362 33.5164H150.058Z",
    fill: "#250201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.305 44.1148H215.704V54.0004H224.905V44.1148H231.719V36.1799H224.905V0.731909H212.891L190.295 36.444V44.1148H190.305ZM215.816 36.1799H200.186V35.7633L215.399 11.6538H215.816V36.1799ZM238.574 54.0004H275.083V45.9334H251.888V45.5676L261.069 36.2307C271.417 26.2943 274.281 21.4582 274.281 15.4435C274.281 6.52307 267.03 -0.00976562 256.316 -0.00976562C245.602 -0.00976562 238.27 6.54338 238.27 16.6627H247.45C247.45 11.2271 250.883 7.82353 256.184 7.82353C261.485 7.82353 265.019 10.9223 265.019 15.9413C265.019 20.3914 262.318 23.5613 257.068 28.8952L238.584 47.0205V53.9902L238.574 54.0004Z",
    fill: "#250201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.957 44.1049L222.286 0.711914H212.587L184.964 44.0948H194.957V44.1049Z",
    fill: "#D6AE68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_1237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 275.062,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea42Logo);
export default __webpack_public_path__ + "static/media/area42-logo.db9f75b921d6641b1b78c6ab607a4bd0.svg";
export { ForwardRef as ReactComponent };